import apiClient from "@/services/apiClient";


const client = apiClient;

export const studentDocumentsService = {
  getDocuments: async () => {
    const response = await client.get("/StudentDocuments");
    return response.data;
  },

  getEnrollmentDocuments: async (studentEnrollmentId) => {
    const response = await client.get("/StudentDocuments/enrollment", {
      params: studentEnrollmentId ? { studentEnrollmentId } : undefined,
    });
    return response.data;
  },

  upload: async (values, onUploadProgress) => {
    const formData = new FormData();
    formData.append("StudentDocTypeId", String(values.studentDocTypeId));
    if (values.studentEnrollmentId) formData.append("StudentEnrollmentId", String(values.studentEnrollmentId));
    if (values.issueDate) formData.append("IssueDate", values.issueDate);
    if (values.expiryDate) formData.append("ExpiryDate", values.expiryDate);
    if (values.remarks) formData.append("Remarks", values.remarks);
    if (values.documentDescription) formData.append("DocumentDescription", values.documentDescription);
    formData.append("File", values.file);

    const response = await client.post("/StudentDocuments/upload", formData, { onUploadProgress });
    return response.data;
  },

  download: async (studentDocId) => client.get(`/StudentDocuments/download/${studentDocId}`, {
    responseType: "blob",
  }),

  viewEnrollmentDocument: async (studentDocId) => client.get(`/StudentDocuments/enrollment/${studentDocId}/view`, {
    responseType: "blob",
  }),

  downloadEnrollmentDocument: async (studentDocId) => client.get(`/StudentDocuments/enrollment/${studentDocId}/download`, {
    responseType: "blob",
  }),

  deleteEnrollmentDocument: async (studentDocId) => {
    const response = await client.delete(`/StudentDocuments/enrollment/${studentDocId}`);
    return response.data;
  },
};
